import React from "react";

const TextWithUrlsAndHashTags = ({
  Message,
  text,
  urls = [],
  hashtags = [],
  onHashtagClick,
  actionDisabled,
  tagActivityTenantId,
  style = {},
}) => {
  const renderTextWithLinksAndTags = (inputText) => {
    const textToRender = inputText || text || Message;
    if (!textToRender) return null;

    // normalize escaped \n into real newlines
    const normalized = textToRender.replace(/\\n/g, "\n");

    // split into lines first
    const lines = normalized.split("\n");

    const urlList = Array.isArray(urls)
      ? urls
      : typeof urls === "string" && urls
      ? [urls]
      : [];

    const isUrlRegex = /^(https?:\/\/|www\.|[a-zA-Z0-9-]+\.(com|org|net|io|co|in|edu|gov|me|info|biz|dev|app|store|tech)(\/|\b|\?|#))/i;
    const hashtagList = Array.isArray(hashtags) ? hashtags : [];

    return lines.map((line, lineIndex) => (
      <React.Fragment key={lineIndex}>
        {line.split(/\s+/).map((part, index) => {
          if (!part) return null;

          const isUrl =
            (urlList.length > 0 && urlList.some((url) => url && part.includes(url))) ||
            isUrlRegex.test(part);

          // URL case
          if (isUrl) {
            let url = part;
            if (!/^https?:\/\//i.test(url)) {
              url = "https://" + part;
            }
            return (
              <a
                href={url}
                target="_blank"
                key={index}
                rel="noopener noreferrer"
              >
                {"related link "}
              </a>
            );
          }

          // Hashtag case
          const cleanPart = part.trim();
          const isHashtag =
            (cleanPart.startsWith("#") && cleanPart.length > 1) ||
            hashtagList.some(
              (hashtag) =>
                hashtag &&
                (cleanPart === hashtag ||
                  cleanPart === `#${hashtag}` ||
                  `#${cleanPart}` === hashtag)
            );

          if (isHashtag) {
            return (
              <span
                style={{
                  color: "#007bff",
                  cursor: onHashtagClick ? "pointer" : "default",
                  fontSize: "14px",
                }}
                key={index}
                onClick={() => {
                  if (onHashtagClick) {
                    const rawTag = cleanPart.startsWith("#")
                      ? cleanPart.slice(1)
                      : cleanPart;
                    onHashtagClick(
                      tagActivityTenantId
                        ? { hashtag: rawTag, tenantId: tagActivityTenantId }
                        : rawTag
                    );
                  }
                }}
              >
                {`${part} `}
              </span>
            );
          }

          // Default case (plain text)
          return <React.Fragment key={index}>{`${part} `}</React.Fragment>;
        })}
        {/* Add <br /> between lines, but not after the last one */}
        {lineIndex !== lines.length - 1 && <br />}
      </React.Fragment>
    ));
  };

  return (
    <div
      style={{
        fontSize: "14px",
        color: "#050505",
        pointerEvents: actionDisabled ? "none" : "auto",
        opacity: actionDisabled ? 0.6 : 1,
        ...style,
      }}
    >
      {renderTextWithLinksAndTags(text || Message)}
    </div>
  );
};

export default TextWithUrlsAndHashTags;
